import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dc57391"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dictionary-page" }

import { ref } from 'vue'
import SatelliteTable from './components/satellite-table.vue'
import CardTable from './components/card-table.vue'
import ChipTable from './components/chip-table.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const active = ref('satellite')

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: active.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
      class: "tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "卫星",
          name: "satellite"
        }, {
          default: _withCtx(() => [
            _createVNode(SatelliteTable)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "4G卡号",
          name: "card"
        }, {
          default: _withCtx(() => [
            _createVNode(CardTable)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "芯片类型",
          name: "chip"
        }, {
          default: _withCtx(() => [
            _createVNode(ChipTable)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})